export enum Client {
    onePieceServer = 'onePieceServer',
    exchangeSubgraph = 'exchangeSubgraph',
}
